import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { HttpGenericService } from 'src/app/services/http-generic.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { TipoDeMensajeSwal } from 'src/app/models/enums/tipo-de-mensaje-swal';
import { Categoria } from 'src/app/models/categoria';

@Component({
  selector: 'app-categorias-editor',
  templateUrl: './categorias-editor.component.html',
  styleUrls: ['./categorias-editor.component.css']
})
export class CategoriasEditorComponent implements OnInit {

  titulo: string;
  id: number
  modelo: Categoria = new Categoria();
  procesando: boolean = false;

  constructor(
    public bsModalRef: BsModalRef, 
    private httpGeneric: HttpGenericService, 
    private swal: SweetAlertService) { }

  ngOnInit() {}

  getCategoriaPorId(id: number) {
    this.httpGeneric.get(`categorias/${id}`)
      .subscribe(data => {
        this.modelo = data;
      }, err => {
        this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, intente mas tarde', '');
      });
  }

  guardar() {
    this.procesando = true;

    let url: any;

    if(!this.modelo.id) {
      url = this.httpGeneric.post('categorias', this.modelo)
    }
    else {
      url = this.httpGeneric.put('categorias/' + this.modelo.id, this.modelo)
    }

    url
    .subscribe(data => {
      this.procesando = false;
      this.swal.mostrar(TipoDeMensajeSwal.Success, 'Registro exitoso', '');
      this.bsModalRef.content.recargar = true;
      this.bsModalRef.hide();
    }, err => {
      this.procesando = false;
      this.swal.mostrar(TipoDeMensajeSwal.Error, 'Ha ocurrido un error, al registrar la información', '');
    });
  }

}
